import AssetImage from "./AssetImage";

/** Public merchant/platform identity shared by section and full-page loaders. */
export default function LoaderBrand({ brand }) {
  const name = typeof brand?.name === "string" ? brand.name.trim() : "";
  if (!name) return null;
  const initials = name.split(/\s+/).slice(0, 2).map(word => Array.from(word)[0]).join("").toUpperCase();
  const fallback = <span className="global-request-brand-initials" aria-hidden="true">{initials}</span>;
  return <div className="global-request-brand" data-testid="global-request-brand">
    <div className="global-request-brand-logo">{brand.logoUrl
      ? <AssetImage key={`${brand.scope}:${brand.merchantCode}:${brand.logoUrl}`} src={brand.logoUrl} merchantCode={brand.merchantCode}
          alt={`${name} logo`} className="global-request-brand-image" fallback={fallback} />
      : fallback}</div>
    <p className="global-request-brand-name">{name}</p>
  </div>;
}
